import { Payer } from "@redotech/congo-enums/payer";
import { t } from "@redotech/redo-i18n";
import ToolIcon from "@redotech/redo-icons/tool-02.svg";
import { Step as ModelStep } from "@redotech/redo-return-core-common/return-flow";
import { submitRepairFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isSubmitRepairStepValid,
  SubmitRepairState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SUBMIT_REPAIR = (
  Details: React.ComponentType<StepTypeDetailsProps<SubmitRepairState>>,
): StepType<SubmitRepairState, ModelStep.SubmitRepair> => ({
  Details: (props: StepTypeDetailsProps<SubmitRepairState>) =>
    React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  title: STEP_TYPE_NAMES[ModelStep.SUBMIT_REPAIR],
  valid(state) {
    return isSubmitRepairStepValid(state).valid;
  },
  Icon: ToolIcon,
  iconColor: "success",
  description() {
    return t("Submit a repair request");
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: {
    option: {
      labelPayer: Payer.Customer,
      chargeFee: false,
      repairFee: { strategy: ModelStep.RepairFeeMode.Free },
    },
  },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SUBMIT_REPAIR,
      option: {
        labelPayer: state.option.labelPayer,
        // Kept in sync with repairFee for readers of the legacy flag.
        chargeFee:
          state.option.repairFee.strategy !== ModelStep.RepairFeeMode.Free,
        repairFee: state.option.repairFee,
      },
    };
  },
  fromModel(model) {
    return submitRepairFromModel(model);
  },
});

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export {
  type SubmitRepairOption,
  type SubmitRepairState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
